export function generateNumber(n: number) {
  return +(((1 + Math.random() * 9) | 0) + [...Array(n - 1)].map(_ => (Math.random() * 10) | 0).join(''));
}

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param val The initial value
 * @param min The lower boundary
 * @param max The upper boundary
 *
 * @example
 * clamp(-10, 20, 30) // returns 20
 * clamp(25, 20, 30)  // returns 25
 * clamp(500, 20, 30) // returns 30
 */
export function clamp(val: number, min: number, max: number) {
  return Math.min(Math.max(val, min), max);
}

export function truncateTo2Decimals(value: number) {
  return Math.floor(value.valueOf() * 100) / 100;
}

export function stringifyNumberWithLetters(num: number) {
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1).replace(/\.0$/, '')}m`;
  }
  if (num >= 1000) {
    return `${(num / 1000).toFixed(1).replace(/\.0$/, '')}k`;
  }
  return num.toString();
}
